import type {tabsAnatomy} from '@chakra-ui/anatomy';
import type {useStyleConfig} from '@chakra-ui/react';
import {useMultiStyleConfig} from '@chakra-ui/react';
import type {SystemStyleObject} from '@chakra-ui/styled-system';
import {createMultiStyleConfigHelpers} from '@chakra-ui/styled-system';

import {fill} from './TabsVariantFill';
import {indicator} from './TabsVariantIndicator';
import {underline} from './TabsVariantUnderline';
import {anatomy} from './anatomy';

type Part = (typeof tabsAnatomy.keys)[number] | `badge`;

const {defineMultiStyleConfig} = createMultiStyleConfigHelpers(anatomy);

const TabsTheme = defineMultiStyleConfig({
  baseStyle: {
    tab: {
      fontSize: `base`,
    },
  },
  variants: {
    indicator,
    underline,
    fill,
  },
  defaultProps: {
    size: `md`,
    variant: `indicator`,
    colorScheme: `brand.primary`,
  },
});

export default TabsTheme;

export const useTabsStyleConfig = (props: Parameters<typeof useStyleConfig>[1]): Record<Part, SystemStyleObject> => {
  return useMultiStyleConfig(`Tabs`, props);
};
